var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rb-modal",
    {
      class: _vm.$style.dialog,
      on: {
        cancel: function ($event) {
          return _vm.cancel()
        },
        hide: function ($event) {
          return _vm.submit()
        },
      },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Send Reminder Email"),
      ]),
      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
        _vm._v(
          " You have selected " +
            _vm._s(_vm.bidsCountLabel) +
            " to send reminder emails to. Are you sure you want to continue? "
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "layout-row",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("div", { staticStyle: { flex: "1" } }, [_vm._v(" ")]),
          _c("div", { staticClass: "flex-hold" }, [
            _c(
              "button",
              {
                staticClass: "rbButton",
                on: {
                  click: function ($event) {
                    return _vm.cancel()
                  },
                },
              },
              [_vm._v(" Cancel ")]
            ),
            _c(
              "button",
              {
                staticClass: "rbButton mainButton",
                on: {
                  click: function ($event) {
                    return _vm.submit()
                  },
                },
              },
              [_vm._v(" Send ")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }